export default "__VITE_ASSET__DoiwAiK8__"